import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

// https://github.com/ReactTraining/react-router/issues/4860#issuecomment-290199229
const withRouterConnect =
  (...connectArgs) =>
  (component) =>
    withRouter(connect(...connectArgs)(component));

export default withRouterConnect;
